import { render, staticRenderFns } from "./BillingAnomalyDetection.vue?vue&type=template&id=80c5407c&"
import script from "./BillingAnomalyDetection.vue?vue&type=script&lang=js&"
export * from "./BillingAnomalyDetection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports